export { supported as webGLSupported } from '@mapbox/mapbox-gl-supported'
